export default __webpack_public_path__ + "static/media/cif-mn.af1756a1.svg";